import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllOrganizationList: [],
  getActiveOrganizationsList: [],
  getOrganizationById: [],
  getAllOrganizationDropdown: [],
  organizationTotal: '',
  filteredOrganizationTotal: '',
  organizationAPICall: false,
  organizationLoading: false,
  defaultNotificationTemplate: [],
  ehrFilterOrganizationList: [],
  organizationUploadedLogoUrl: '',
  logoUploadLoading: false,
  logoUploadSuccess: null,
  fronteggPlans: [],
  dacCSVSettings: {},
  dacCSVSettingsLoading: false,
  isDACCSVSettingsEnabled: false,
  isDACCSVSettingsEnabledLoading: false,
  patientSummaryNotificationSetting: false,
  patientSummaryNotificationSettingLoading: false,
  hQOrganizationsList: [],
};

const organizationSlice = createSlice({
  name: 'organizationSlice',
  initialState,
  reducers: {
    getAllOrganizationListSlice: (state, { payload }) => {
      state.getAllOrganizationList = payload;
    },
    getOrganizationByIdSlice: (state, { payload }) => {
      state.getOrganizationById = payload;
    },
    getActiveOrganizationsListSlice: (state, { payload }) => {
      state.getActiveOrganizationsList = payload;
    },
    getAllOrganizationDropdownSlice: (state, { payload }) => {
      state.getAllOrganizationDropdown = payload;
    },
    organizationTotalSlice: (state, { payload }) => {
      state.organizationTotal = payload;
    },
    filteredOrganizationTotalSlice: (state, { payload }) => {
      state.filteredOrganizationTotal = payload;
    },
    organizationAPICallSlice: (state, { payload }) => {
      state.organizationAPICall = payload;
    },
    organizationLoadingSlice: (state, { payload }) => {
      state.organizationLoading = payload;
    },
    defaultNotificationTemplateSlice: (state, { payload }) => {
      state.defaultNotificationTemplate = payload;
    },
    ehrFilterOrganizationListSlice: (state, { payload }) => {
      state.ehrFilterOrganizationList = payload;
    },
    organizationUploadedLogoUrlSlice: (state, { payload }) => {
      state.organizationUploadedLogoUrl = payload;
    },
    logoUploadLoadingSlice: (state, { payload }) => {
      state.logoUploadLoading = payload;
    },
    logoUploadSuccessSlice: (state, { payload }) => {
      state.logoUploadSuccess = payload;
    },
    fronteggPlansSlice: (state, { payload }) => {
      state.fronteggPlans = payload;
    },
    dacCSVSettingsSlice: (state, { payload }) => {
      state.dacCSVSettings = payload;
    },
    dacCSVSettingsLoadingSlice: (state, { payload }) => {
      state.dacCSVSettingsLoading = payload;
    },
    isDACCSVSettingsEnabledSlice: (state, { payload }) => {
      state.isDACCSVSettingsEnabled = payload;
    },
    isDACCSVSettingsEnabledLoadingSlice: (state, { payload }) => {
      state.isDACCSVSettingsEnabledLoading = payload;
    },
    patientSummaryNotificationSettingSlice: (state, { payload }) => {
      state.patientSummaryNotificationSetting = payload;
    },
    patientSummaryNotificationSettingLoadingSlice: (state, { payload }) => {
      state.patientSummaryNotificationSettingLoading = payload;
    },
    hQOrganizationsListSlice: (state, { payload }) => {
      state.hQOrganizationsList = payload;
    },
  },
});

const { actions, reducer } = organizationSlice;

export const {
  getAllOrganizationListSlice,
  getActiveOrganizationsListSlice,
  getOrganizationByIdSlice,
  getAllOrganizationDropdownSlice,
  organizationTotalSlice,
  filteredOrganizationTotalSlice,
  organizationAPICallSlice,
  organizationLoadingSlice,
  defaultNotificationTemplateSlice,
  ehrFilterOrganizationListSlice,
  organizationUploadedLogoUrlSlice,
  logoUploadLoadingSlice,
  logoUploadSuccessSlice,
  fronteggPlansSlice,
  dacCSVSettingsSlice,
  dacCSVSettingsLoadingSlice,
  isDACCSVSettingsEnabledSlice,
  isDACCSVSettingsEnabledLoadingSlice,
  patientSummaryNotificationSettingSlice,
  patientSummaryNotificationSettingLoadingSlice,
  hQOrganizationsListSlice,
} = actions;

export default reducer;
